import { Divider, Grid } from '@mui/material';
import { Fragment } from 'react';
import { Control } from 'react-hook-form';

import FormController from 'portal/src/components/common/forms/FormController';

import { AllFormFieldTypes } from './FormFieldTypes';

const FormViewFieldLayout = ({
  control,
  mainFieldsConfig,
  columnNumber = 2,
  isDeactivated = false,
  isReadOnly,
}: {
  control: Control<any>;
  mainFieldsConfig: AllFormFieldTypes[];
  columnNumber?: 1 | 2 | 3;
  isDeactivated?: boolean;
  isReadOnly: boolean;
}) => {
  return (
    <Grid container spacing={2} alignItems="flex-start">
      {mainFieldsConfig.map((fieldConf, index) => {
        const { hidden, prependDivider } = fieldConf;

        return (
          <Fragment key={index}>
            {prependDivider && (
              <Divider sx={{ width: '100%' }}>
                {typeof prependDivider === 'string' ? prependDivider : ''}
              </Divider>
            )}
            <Grid
              display={hidden ? 'none' : 'grid'}
              size={{
                xs: 12,
                md: 12 / columnNumber,
              }}
            >
              <FormController
                control={control}
                fieldConf={fieldConf}
                isViewMode={isDeactivated || isReadOnly}
              />
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
};

export default FormViewFieldLayout;
